import { useEffect } from 'react';

import {
  useArchivedJobProspectsActions
} from './ArchivedJobProspectsContext';

import {
  getArchivedJobProspects,
} from './restApi';

const ArchivedJobProspectsLoader = () => {
  const { initializeState, onResponse, onError } = useArchivedJobProspectsActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getArchivedJobProspects({
      onResponse,
      onError,
      body: {
        pageNumber: 1,
      },
    });
  }, []);

  return null;
};

export default ArchivedJobProspectsLoader;
